import React, {Component} from 'react'

export default class RegulaminPrzewozow extends Component {

    render() {
        return <div className="panelPaddingMobilka"
                    style={{background: '#f9f9f9', paddingTop: '25px', paddingBottom: '25px'}}>
            <div className="container" style={{background: '#fff', padding: 0}}>
                <div className="aktualnosci ramka">
                    <div className="row" style={{width: '100%'}}>
                        <div className="col-sm-12 text-center" style={{paddingTop: 75}}>
                            <h2 style={{fontWeight: 'bold'}}>Regulamin ogólny</h2>
                            <hr/>
                            <div className="text-left" style={{margin: 50}}>
                                <p><strong><u>REGULAMIN</u></strong></p>
                                <p>Niniejszy Regulamin określa zasady korzystania z usług firmy MARCEL Sp. z o.o. Sp.
                                    k.,
                                    obsługi
                                    Klientów,
                                    warunków przewozu Pasażerów i bagażu.</p>
                                <p>Postanowienia Regulaminu obowiązują we wszystkich środkach transportu MARCEL Sp. z
                                    o.o.
                                    Sp. k. na
                                    liniach
                                    regularnych, trasach krajowych i zagranicznych.</p>
                                <p>&nbsp;</p>
                                <ol>
                                    <li><strong> WARUNKI OGÓLNE PRZEWOZU.</strong></li>
                                </ol>
                                <p><strong>1.1. </strong>Umowę przewozu z firmą MARCEL Sp. z o.o. Sp. k. zawiera się
                                    poprzez
                                    nabycie
                                    biletu
                                    na przejazd. Na bilecie jednorazowym określona jest: nazwa przewoźnika, data wraz z
                                    godziną
                                    zakupu i
                                    wysokość należności za przejazd, zgodna z obowiązującym cennikiem. Bilet jest
                                    ubezpieczeniem na
                                    czas
                                    przejazdu. Nabycie biletu jest równoznaczne z zaakceptowaniem niniejszego Regulaminu
                                    przez
                                    Pasażera.</p>
                                <p><strong>1.2.</strong> Prawo zajęcia miejsca w autobusie na przystanku początkowym
                                    przysługuje w
                                    pierwszej
                                    kolejności Pasażerowi z ważnym biletem miesięcznym, następnie Pasażerowi, który
                                    dokonał
                                    telefonicznej
                                    rezerwacji miejsca (dotyczy linii Rzeszów-Kraków i Rzeszów-Lublin), a w dalszej
                                    kolejności
                                    Pasażerowi,
                                    który zakupił bilet jednorazowy u kierowcy.</p>
                                <p><strong>1.3</strong>. Rezerwacji na linii Rzeszów-Kraków i Rzeszów-Lublin dokonuje
                                    się
                                    bez
                                    możliwości
                                    wskazania konkretnego miejsca w autobusie. Rezerwacja jest możliwa wyłącznie dla
                                    Pasażerów
                                    korzystających z przejazdu na całej trasie. Rezerwacja jest bezpłatna i wygasa 10
                                    minut
                                    przed
                                    planowaną
                                    godziną odjazdu.</p>
                                <p><strong>1.4. </strong>Pasażer uprawniony do korzystania z ulg zobowiązany jest na
                                    wezwanie
                                    kierowcy lub
                                    osób dokonujących kontroli okazać ważny dokument poświadczający ustawowe uprawnienie
                                    do
                                    korzystania z
                                    ulg.</p>
                                <p><strong>1.5. </strong>Wsiadanie i wysiadanie z pojazdu jest dozwolone po całkowitym
                                    zatrzymaniu
                                    się
                                    pojazdu i wyłącznie w miejscach określonych w rozkładzie jazdy.</p>
                                <p><strong>1.6. </strong>Zabrania się przewożenia zwierząt w środkach transportu firmy
                                    MARCEL Sp. z
                                    o.o. Sp.
                                    k.</p>
                                <p><strong>1.7.</strong> Zabrania się spożywania alkoholu, palenia papierosów oraz
                                    jedzenia
                                    w
                                    środkach
                                    transportu firmy MARCEL Sp. z o.o. Sp.k. Pasażerowie nie stosujący się do wskazanych
                                    powyżej
                                    zakazów
                                    zostaną natychmiast usunięci z pojazdu.</p>
                                <p><strong>1.8.</strong> Kierowca ma prawo odmówić przejazdu osobie znajdującej się pod
                                    wpływem
                                    alkoholu lub
                                    wysadzić Pasażera, który utrudnia prowadzenie pojazdu (np. zachowuje się agresywnie,
                                    niekulturalnie,
                                    wulgarnie wobec kierowcy albo współpasażerów).</p>
                                <p><strong>1.9. </strong>W przypadku odmowy opuszczenia pojazdu, kierowca ma prawo
                                    zwrócić
                                    się o
                                    interwencję
                                    do organów Policji lub innych uprawnionych służb.</p>
                                <p><strong>1.10. </strong>Surowo zabronione jest przewożenie niebezpiecznego bagażu,
                                    który
                                    zagraża
                                    bezpieczeństwu pozostałych Pasażerów lub może spowodować uszkodzenie pojazdu lub
                                    mienia.
                                </p>
                                <p><strong>1.11. </strong>Przewoźnik może odmówić przewozu bagażu o dużych wymiarach,
                                    który
                                    trudno
                                    jest
                                    umieścić w luku bagażowym.</p>
                                <p><strong>1.12. </strong>Podróżny jest obowiązany do przestrzegania przepisów
                                    porządkowych
                                    obowiązujących w
                                    transporcie oraz określonych niniejszym Regulaminem.</p>
                                <p><strong>1.13. </strong>MARCEL Sp. z o.o. Sp. k. zastrzega sobie prawo do wprowadzenia
                                    zmian w
                                    niniejszym
                                    Regulaminie. Zmieniony Regulamin nie będzie stosowany do umów przewozu zawartych
                                    przed
                                    dniem
                                    wejścia w
                                    życie zmian.</p>
                                <p>&nbsp;</p>
                                <ol start="2">
                                    <li><strong> BILETY JEDNORAZOWE I MIESIĘCZNE.</strong></li>
                                </ol>
                                <p><strong>2.1.</strong> Zakup biletu jednorazowego na przejazdy regularne środkami
                                    transportu
                                    MARCEL Sp. z
                                    o.o. Sp. k jest możliwy u kierowcy, w kasie Regionalnego Dworca Autobusowego w
                                    Krakowie
                                    (dotyczy
                                    połączenia Kraków – Rzeszów), w kasie Dworca Autobusowego w Lublinie (dotyczy
                                    połączenia
                                    Lublin
                                    –
                                    Rzeszów) lub w przedsprzedaży poprzez stronę internetową firmy <strong><a
                                        href="https://marcel-bus.pl/">www.marcel-bus.pl</a></strong> (dotyczy połączeń
                                    do
                                    Krakowa i
                                    Lublina).</p>
                                <p><strong>2.2.</strong> Jednorazowe bilety zakupione on-line na trasach Rzeszów –
                                    Kraków
                                    oraz
                                    Rzeszów –
                                    Lublin są biletami imiennymi i upoważniają tylko i wyłącznie do przejazdu tego
                                    Pasażera,
                                    który
                                    zakupił
                                    bilet w systemie on-line. Do przejazdu uprawiona jest tylko i wyłącznie osoba, na
                                    którą
                                    wystawiony jest
                                    bilet. Podczas dokonywania zakupu biletu należy podać imię i nazwisko Pasażera,
                                    który
                                    będzie
                                    korzystał z
                                    przejazdu. Kierowca uprawniony jest do weryfikacji tożsamości osób wsiadających z
                                    biletami, w
                                    tym celu
                                    ma prawo żądania okazania przez Pasażera dokumentu tożsamości z aktualnym zdjęciem.
                                    W
                                    przypadku
                                    niezgodności tożsamości osoby, na którą bilet został wystawiony – bilet traci
                                    ważność i
                                    nie
                                    podlega
                                    zwrotowi. Bilety imienne nie mogą być odsprzedawane przez Pasażerów.</p>
                                <p><strong>2.3. </strong>Bilet zniszczony, uszkodzony lub poprawiony jest nieważny.</p>
                                <p><strong>2.4. </strong>Koszt duplikatu biletu miesięcznego wynosi 30,00 zł.</p>
                                <p><strong>2.5</strong>. Bilety miesięczne (imienne) wydaje się na okres miesiąca
                                    kalendarzowego
                                    (wszystkie
                                    dni danego miesiąca kalendarzowego), na określone linie, kursy i relacje. W Punkcie
                                    Obsługi
                                    Klienta w
                                    Rzeszowie można zakupić bilet zwykły w obie strony na okres półmiesięczny:</p>
                                <p>– pierwsza połowa: od 1 do 15-tego dnia miesiąca,</p>
                                <p>– druga połowa: od 16 do 30 lub 31-tego dnia miesiąca.</p>
                                <p>Bilet miesięczny jest ważny z dokumentem tożsamości, a w przypadku biletów
                                    miesięcznych
                                    ulgowych,
                                    dodatkowo z dokumentem poświadczającym ustawowe uprawnienia do korzystania z
                                    ulgowych
                                    przejazdów.</p>
                                <p><strong>2.6</strong>. Posiadacze biletów miesięcznych w celu aktualizacji i
                                    weryfikacji
                                    poprawności
                                    informacji zapisanych na EM-Kartach zobowiązani są do zakupu biletu w biurze MARCEL
                                    Sp.
                                    z o.o.
                                    Sp. k.
                                    raz na 8 miesięcy.</p>
                                <p><strong>2.7</strong>. Bilety miesięczne na kolejny miesiąc kalendarzowy można zakupić
                                    od
                                    22 dnia
                                    każdego
                                    miesiąca u kierowcy pojazdu oraz w CH EUROPA II w Rzeszowie. Możliwość zakupu biletu
                                    u
                                    kierowcy
                                    pojazdu
                                    dotyczy tylko biletów na cały miesiąc. Bilet wykupiony na pół miesiąca może zostać
                                    przedłużony
                                    tylko i
                                    wyłącznie w Punkcie Obsługi Klienta.</p>
                                <p><strong>2.8.</strong> Przewoźnik ma prawo pozyskiwać dane osobowe (imię, nazwisko,
                                    adres)
                                    od
                                    Pasażerów,
                                    które są niezbędne do zawarcia umowy przewozu osób i sprzedaży biletów miesięcznych
                                    (zwłaszcza
                                    wydania
                                    karty biletu miesięcznego).</p>
                                <p><strong>2.9. </strong>Pasażer ma obowiązek okazać kierowcy pojazdu przed rozpoczęciem
                                    podróży
                                    zakupiony
                                    wcześniej bilet.</p>
                                <p><strong>2.10.</strong> Do kontroli biletów oraz dokumentów uprawniających do
                                    przejazdów
                                    ulgowych
                                    upoważniona jest obsługa środka transportu oraz inne wyznaczone przez przewoźnika
                                    osoby
                                    posiadające
                                    odpowiednie identyfikatory umieszczone w widocznym miejscu. Pasażer zobowiązany jest
                                    do
                                    okazania
                                    biletu
                                    miesięcznego, dokumentów uprawniających do przejazdów ulgowych oraz paragonu ww.
                                    osobom.
                                </p>
                                <p><strong>2.11.</strong> W przypadku stwierdzenia, że w pojeździe przebywa Pasażer bez
                                    ważnego
                                    biletu,
                                    osoby wskazane w pkt 2.10 Regulaminu, mają prawo do wylegitymowania takiego Pasażera
                                    oraz mogą
                                    oprócz
                                    pobrania właściwej należnej opłaty za przewóz, nałożyć na Pasażera opłatę dodatkową
                                    w
                                    wysokości
                                    50–krotności ceny biletu obowiązującej za przejazd na danej trasie, płatną
                                    bezpośrednio
                                    u
                                    Kierowcy lub w
                                    Punkcie Obsługi Klienta.</p>
                                <p><strong>2.12.</strong> Do zakupu biletu miesięcznego konieczny jest dodatkowo nr
                                    PESEL
                                    Klienta,
                                    który
                                    jest jedynym unikatowym numerem ewidencji i umożliwia ewentualne dochodzenie
                                    roszczeń.
                                </p>
                                <p><strong>2.13.</strong> Przewoźnik honoruje ulgi wynikające z ustawy z dnia 20 czerwca
                                    1992 r. o
                                    uprawnieniach do ulgowych przejazdów środkami publicznego transportu zbiorowego (Dz.
                                    U.
                                    z 2002
                                    r., Nr
                                    175, poz. 1440 ze zm.).</p>
                                <p><strong>2.14.</strong> Do zakupu biletu z ulgą ustawową niezbędna jest ważna
                                    legitymacja
                                    lub inny
                                    dokument potwierdzający uprawnienie Pasażera do bezpłatnego przejazdu lub ulgi.</p>
                                <p><strong>2.15.</strong> W przypadku stwierdzenia, że w pojeździe przebywa Pasażer bez
                                    dokumentu
                                    poświadczającego</p>
                                <p>uprawnienie Pasażera do bezpłatnego albo ulgowego przejazdu, Osoby wskazane w pkt
                                    2.10
                                    Regulaminu
                                    mogą
                                    wylegitymować Pasażera oraz oprócz pobrania właściwej należnej opłaty za przewóz,
                                    nałożyć na
                                    Pasażera
                                    opłatę dodatkową w wysokości 40–krotności wysokości ceny biletu obowiązującego za
                                    przejazd na
                                    danej
                                    trasie, płatną bezpośrednio u Kierowcy lub w Punkcie Obsługi Klienta.</p>
                                <p><strong>2.16.</strong> Podczas całej podróży Pasażerowie mają obowiązek posiadać
                                    ważny
                                    bilet.
                                    Pasażer
                                    powinien zachować bilet także po zakończeniu podróży na wypadek ewentualnej
                                    reklamacji.
                                </p>
                                <p><strong>2.17.</strong> Opłatę, o której mowa w pkt 2.11 Regulaminu stosuje się
                                    również w
                                    przypadku
                                    stwierdzenia, że Pasażer zabrał do pojazdu rzeczy wyłączone z przewozu lub
                                    spowodował
                                    bez
                                    uzasadnionej
                                    przyczyny zatrzymanie, opóźnienie albo zmianę trasy przejazdu pojazdu.</p>
                                <p>&nbsp;</p>
                                <ol start="3">
                                    <li><strong> ZMIANA I ZWROT BILETU</strong>.</li>
                                </ol>
                                <p><strong>3.1.</strong> Za niewykorzystany bilet na przejazd jednorazowy, Przewoźnik
                                    obowiązany
                                    jest
                                    zwrócić stosowną kwotę zapłaconej należności pod warunkiem, że Podróżny dokona
                                    zwrotu
                                    lub uzyska
                                    poświadczenie niewykorzystania biletu przed rozpoczęciem podróży. Niewykorzystany
                                    bilet
                                    jednorazowy
                                    można zwrócić w kasie nabycia biletu lub w Punkcie Obsługi Klienta znajdującym się w
                                    CH
                                    EUROPA
                                    II przed
                                    rozpoczęciem przejazdu.</p>
                                <p><strong>3.2.</strong> W przypadku częściowego niewykorzystania biletu, Pasażer w celu
                                    uzyskania
                                    zwrotu
                                    części uiszczonej należności za bilet, powinien uzyskać od kierowcy pojazdu
                                    poświadczenie
                                    opuszczenia
                                    środka transportu przed zakończeniem planowanej podróży.</p>
                                <ul>
                                    <li>Poświadczenia o niewykorzystaniu biletu dokonuje:</li>
                                </ul>
                                <ol>
                                    <li>przed rozpoczęciem przejazdu &#8211; uprawniony pracownik Przewoźnika w
                                        początkowym
                                        punkcie
                                        odprawy,
                                    </li>
                                    <li>po rozpoczęciu przejazdu (w razie częściowego niewykorzystania
                                        biletu) &#8211; obsługa
                                        pojazdu.
                                    </li>
                                </ol>
                                <p><strong>3.4.</strong> Należność za częściowo niewykorzystane bilety zwraca się
                                    wyłącznie
                                    na
                                    podstawie
                                    reklamacji pisemnej, poprzez kasę główną Przewoźnika.</p>
                                <p><strong>3.5.</strong> Do obliczenia zwracanej należności przyjmuje się:</p>
                                <ol>
                                    <li>a) za bilety na przejazd jednorazowy:</li>
                                </ol>
                                <p>– w razie całkowitego niewykorzystania biletu &#8211; zapłaconą należność,</p>
                                <p>– w razie częściowego niewykorzystania biletu &#8211; różnicę między zapłaconą
                                    należnością, a
                                    należnością
                                    przypadającą za wykonane świadczenie,</p>
                                <ol>
                                    <li>b) za bilety na przejazd wielokrotny:</li>
                                </ol>
                                <p>– zapłaconą należność za bilet zwrócony przed pierwszym dniem terminu jego ważności
                                    (zwrotu
                                    dokonuje kasa
                                    biletowa),</p>
                                <p>– należność proporcjonalną do liczby niewykorzystanych przejazdów, o ile bilet został
                                    zwrócony w
                                    okresie
                                    jego ważności, w trybie pisemnej reklamacji.</p>
                                <p><strong>3.6.</strong> Nie przysługuje zwrot należności za bilety niewykorzystane z
                                    przyczyn
                                    leżących po
                                    stronie Podróżnego, zwracane po terminie ich ważności lub po odjeździe środka
                                    transportu, w
                                    którym
                                    powinny być wykorzystane, chyba że Podróżny uzyskał poświadczenie niewykorzystania
                                    biletu lub
                                    udokumentował, że nie mógł go wykorzystać z powodu choroby albo innych ważnych
                                    przyczyn
                                    od niego
                                    niezależnych.</p>
                                <p><strong>3.7</strong> Od zwracanych Pasażerowi przez Przewoźnika należności zgodnie z
                                    art.
                                    17 ust.
                                    4
                                    Ustawy prawo przewozowe, Przewoźnik potrąca 20% odstępnego.</p>
                                <p><strong>3.8</strong> Nie stosuje się potrącenia odstępnego i zwraca Podróżnemu całą
                                    należność
                                    zapłaconą
                                    za przejazd, jeżeli odstąpił on od umowy przewozu z przyczyn występujących po
                                    stronie
                                    Przewoźnika i nie
                                    skorzystał z przewozu zastępczego Przewoźnika.</p>
                                <p>&nbsp;</p>
                                <ol start="4">
                                    <li><strong> WARUNKI PROMOCJI.</strong></li>
                                </ol>
                                <p><strong>4.1. </strong>Liczba biletów objętych promocją jest ograniczona.</p>
                                <ol start="5">
                                    <li><strong> OCHRONA DANYCH OSOBOWYCH.</strong></li>
                                </ol>
                                <p><strong>5.1.</strong> Podanie przez Klienta danych osobowych jest dobrowolne, ale
                                    konieczne do
                                    wykonania
                                    usługi. Odmówienie podania danych osobowych może skutkować brakiem zgody na
                                    świadczenie
                                    usług
                                    przez
                                    firmę MARCEL Sp. z o.o. Sp. K.</p>
                                <p><strong>5.2.</strong> Administratorem danych osobowych jest firma MARCEL Sp. z o.o.
                                    Sp.
                                    k. z
                                    siedzibą w
                                    Rzeszowie przy ul. Architektów 1B, która zobowiązuje się chronić dane osobowe
                                    zgodnie z
                                    obowiązującymi
                                    przepisami prawa w tym zakresie, a w szczególności z Rozporządzeniem Parlamentu
                                    Europejskiego i
                                    Rady
                                    (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku
                                    z
                                    przetwarzaniem
                                    danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia
                                    dyrektywy
                                    95/46/WE.</p>
                                <p><strong>5.3.</strong> Pasażer ma prawo do wglądu do treści swoich danych osobowych,
                                    ich
                                    zmiany,
                                    poprawienia i przetwarzania.</p>
                                <p><strong>5.4. </strong>Dane osobowe związane z zakupem biletu ulgowego są udostępniane
                                    do
                                    Urzędu
                                    Marszałkowskiego celem ich zaewidencjonowania i potwierdzenia prawa do ulgi w cenie.
                                </p>
                                <p><strong>5.5.</strong> Zbiory danych osobowych są chronione i zabezpieczone przed
                                    nieuprawnionym
                                    dostępem.
                                </p>
                                <p><strong>5.6.</strong> Zakup biletu i przekazanie danych osobowych przez Pasażera jest
                                    jednoznaczne z
                                    wyrażeniem zgody na przetwarzanie jego danych osobowych w celu wykonania umowy
                                    przewozu.
                                </p>
                                <p><strong>5.7.</strong> MARCEL Sp. z o.o. Sp. k. zobowiązuje się do przetwarzania
                                    danych
                                    osobowych
                                    zgodnie
                                    z obowiązującymi przepisami prawa oraz niniejszym Regulaminem, jedynie w zakresie
                                    niezbędnym do
                                    wykonania zobowiązań i uprawnień wynikających z umowy przewozu. Marcel Sp. z o.o.
                                    Sp. k.
                                    może
                                    przetwarzać powierzone mu dane osobowe w formie elektronicznej oraz papierowej.</p>
                                <ol start="6">
                                    <li><strong> WYNAJEM AUTOBUSÓW.</strong></li>
                                </ol>
                                <p><strong>6.1. </strong>Podstawą świadczenia usług wynajmu autobusu przez MARCEL Sp. z
                                    o.o.
                                    Sp. k.
                                    jest
                                    podpisanie umowy zlecenie lub złożenie zamówienia drogą elektroniczną na adres <a
                                        href="mailto:info@marcel-bus.pl"><strong>info@marcel-bus.pl</strong></a></p>
                                <p><strong>6.2. </strong>Wynajem autobusu jest możliwy tylko w przypadku dostępności
                                    autobusu w
                                    określonym
                                    terminie. Zleceniobiorca zastrzega sobie prawo świadczenia ograniczonej ilości
                                    dziennych
                                    usług
                                    wynajmu
                                    środków transportu, wynikających z dostępności floty i kierowców.</p>
                                <p><strong>6.3.</strong> Podstawą wynajmu autobusu na wyjazd zagraniczny jest wpłata
                                    zaliczki w
                                    wysokości
                                    40% wartości wynajmu.</p>
                                <p><strong>6.4. </strong>Umowa powinna zawierać dane Zleceniodawcy (w tym telefon
                                    kontaktowy),
                                    miejsce i
                                    godzinę podstawienia autobusu, ilość pasażerów, dokładny plan wyjazdu i wysokość
                                    wynagrodzenia
                                    za usługę
                                    świadczoną przez firmę MARCEL Sp. z o.o. Sp. k. oraz formę płatności.</p>
                                <p><strong>6.5. </strong>Wszelkie zmiany w zakresie świadczenia usługi muszą być
                                    zgłaszane
                                    przez
                                    Zleceniodawcę odpowiednio wcześniej przed terminem wyjazdu i wymagają akceptacji ze
                                    strony
                                    Zleceniobiorcy, ponadto muszą być dokonane w formie aneksu do umowy.</p>
                                <p><strong>6.6.</strong> W przypadku, gdy Zleceniodawca nie odwoła rezerwacji wynajmu
                                    domniemywa
                                    się, że
                                    zlecenie jest nadal aktualne. Rezygnacji z wynajmu należy dokonać odpowiednio
                                    wcześniej
                                    drogą
                                    mailową:
                                    wynajmy międzynarodowe – 7 dni wcześniej, wynajmy krajowe – 2 dni wcześniej.</p>
                                <p><strong>6.7. </strong>Ceny usług są ustalane indywidualnie na podstawie czasu trwania
                                    wyjazdu,
                                    przejechanych kilometrów, ilości pasażerów i dodatkowych kosztów związanych z
                                    wynajem (w
                                    tym
                                    opłat
                                    drogowych krajowych i zagranicznych, zapewnienie wyżywienie i noclegu kierowcy/-ów).
                                </p>
                                <p><strong>6.8. </strong>Plan wyjazdu musi uwzględniać czas pracy kierowcy/-ów zgodnie z
                                    Rozporządzeniem
                                    (WE) nr 561/2006 określający dopuszczalny czas jazdy/pracy i wymagane przerwy.</p>
                                <p><strong>6.9.</strong> MARCEL Sp. z o.o. Sp. k. odpowiada za stan techniczny autokaru
                                    na
                                    całej
                                    trasie. W
                                    przypadku awarii zobowiązany jest usunąć usterkę lub zapewnić transport zastępczy w
                                    czasie
                                    możliwie jak
                                    najkrótszym, w celu realizowania dalszego programu.</p>
                                <p><strong>6.10. </strong>Za wszelkie usterki i uszkodzenia autobusu spowodowane przez
                                    uczestników w
                                    trakcie
                                    wynajmu odpowiada Zleceniodawca.</p>
                                <p><strong>6.11. </strong>W sprawie nieuregulowania płatności lub innych warunków umowy
                                    przez każdą
                                    ze stron
                                    mają zastosowanie odpowiednie przepisy Kodeksu cywilnego.</p>
                                <ol start="7">
                                    <li><strong> USŁUGI WI-FI – ZASADY KORZYSTANIA.</strong></li>
                                </ol>
                                <p><strong>7.1. </strong>W autobusach firmy MARCEL Sp. z o.o. Sp. k. można korzystać z
                                    bezpłatnego
                                    WI-FI.
                                </p>
                                <p><strong>7.2.</strong> Korzystanie z WI-FI w autobusach MARCEL Sp. z o.o. Sp. k. jest
                                    możliwe
                                    tylko na
                                    terytorium Rzeczypospolitej Polskiej.</p>
                                <p><strong>7.3.</strong> Przewoźnik nie ponosi odpowiedzialności za czasowy brak dostępu
                                    do
                                    usług
                                    WI-FI oraz
                                    za kompatybilność urządzeń Pasażera z infrastrukturą punktu dostępowego.</p>
                                <p><strong>7.4. </strong>Pasażerowi zabrania się korzystania z usług WI-FI polegających
                                    na
                                    przesyłaniu i
                                    udostępnianiu treści, które są niezgodne z prawem i mogą naruszyć dobro osobiste
                                    oraz
                                    rozpowszechniania
                                    wirusów i programów, które mogą uszkodzić urządzenia innych użytkowników.</p>
                                <p><strong>7.5.</strong> Ze względów bezpieczeństwa nie jest gwarantowana dostępność do
                                    wszystkich
                                    usług
                                    sieciowych.</p>
                                <p><strong>7.6.</strong> Pasażer ponosi odpowiedzialność za sposób, w jaki korzysta z
                                    usługi
                                    WI-FI,
                                    w tym za
                                    treści i inną zawartość przesyłanych wiadomości.</p>
                                <p><strong>7.7.</strong> Pasażerowi nie przysługują żadne roszczenia z tytułu czasowego
                                    bądź
                                    stałego
                                    braku
                                    sygnału internetowego lub ograniczenia przepustowości łącza wynikającego z problemów
                                    technicznych.</p>
                                <p><strong>7.8. </strong>W przypadku nieprzestrzegania przez Pasażera postanowień
                                    niniejszego
                                    Regulaminu lub
                                    niezgodnego z przeznaczeniem korzystania z usługi WI-FI, MARCEL Sp. z o.o. Sp. k. ma
                                    prawo
                                    zablokować
                                    dostęp do usługi WI-FI lub ograniczyć szybkość łącza.</p>
                                <p><strong>7.9.</strong> Hasło do WI-FI na linii Rzeszów – Kraków to 00000000 (8 zer),
                                    na
                                    pozostałych
                                    trasach dostęp nie jest zabezpieczony hasłem.</p>
                                <ol start="8">
                                    <li><strong> REKLAMACJE, SKARGI I ODPOWIEDZIALNOŚĆ PRZEWOZNIKA.</strong></li>
                                </ol>
                                <p><strong>8.1.</strong> Firma MARCEL Sp. z o.o. Sp. k. nie ponosi odpowiedzialności za
                                    rzeczy
                                    pozostawione
                                    w środku transportu lub lukach bagażowych, w tym za ich zaginięcie lub zniszczenie.
                                </p>
                                <p><strong>8.2.</strong> Przewoźnik nie ponosi odpowiedzialności za sposób umieszczenia
                                    bagażu w
                                    luku
                                    bagażowym i za jego zabezpieczenie oraz ewentualne zniszczenie lub uszkodzenie,
                                    chyba że
                                    zniszczenie lub
                                    uszkodzenie to wynika z winy przewoźnika. O ewentualnym uszkodzeniu bagażu lub jego
                                    zaginięciu
                                    należy
                                    niezwłocznie poinformować obsługę środka transportu.</p>
                                <p><strong>8.3.</strong> W przypadku awarii środka transportu firma MARCEL Sp. z o.o.
                                    Sp. k.
                                    jest
                                    zobowiązana w czasie możliwie jak najkrótszym usunąć usterkę lub zapewnić zastępczy
                                    środek
                                    transportu
                                    celem kontynuowania przejazdu.</p>
                                <p><strong>8.4. </strong>MARCEL Sp. z o.o. Sp. k. nie odpowiada za opóźnienia kursów i
                                    wszystkie
                                    konsekwencje z nich wynikające, które powstały z przyczyn niezależnych od
                                    przewoźnika, a
                                    w
                                    szczególności
                                    na skutek wypadku komunikacyjnego, warunków atmosferycznych, kontroli organów władz
                                    państwowych
                                    lub
                                    dużego natężenia ruchu.</p>
                                <p><strong>8.5. </strong>Pasażer odpowiada za wszelkie szkody wyrządzone Przewoźnikowi
                                    lub
                                    innm
                                    Podróżnym na
                                    zasadach określonych przepisami prawa.</p>
                                <p><strong>8.6.</strong> Wszelkie reklamacje i uwagi należy kierować:</p>
                                <ul>
                                    <li>korespondencyjnie na adres mailowy: <a
                                        href="mailto:info@marcel-bus.pl"><strong>info@marcel-bus.pl</strong></a></li>
                                    <li>bezpośrednio<strong> </strong>u Pracowników w Punkcie Obsługi Klienta w CH
                                        Europa II
                                        przy
                                        ul.
                                        Piłsudskiego 34 w Rzeszowie,
                                    </li>
                                    <li>pisemnie na adres: MARCEL Sp. z o.o. Sp. k., ul. Architektów 1B, 35-105 Rzeszów.
                                    </li>
                                </ul>
                                <p><strong>8.7.</strong> Reklamację składa się w formie pisemnej. Reklamacja powinna
                                    zawierać:</p>
                                <p>1) datę sporządzenia reklamacji;</p>
                                <p>2) nazwę i siedzibę przewoźnika;</p>
                                <p>3) imię i nazwisko (nazwę) i adres zamieszkania (siedzibę) osoby składającej
                                    reklamację;</p>
                                <p>4) tytuł oraz uzasadnienie reklamacji;</p>
                                <p>5) kwotę roszczenia (oddzielnie dla każdego dokumentu przewozowego);</p>
                                <p>6) wykaz załączonych dokumentów;</p>
                                <p>7) podpis osoby uprawnionej do wniesienia reklamacji.</p>
                                <p><strong>8.8. </strong>Do reklamacji powinny być dołączone, odpowiednio do przedmiotu
                                    roszczenia,
                                    oryginały dokumentów dotyczących zawarcia umowy przewozu (w szczególności bilet na
                                    przejazd,
                                    kwit
                                    bagażowy, dokumenty potwierdzające przyjęcie do przewozu rzeczy innych niż
                                    przesyłka)
                                    oraz
                                    potwierdzone
                                    kopie innych dokumentów związanych z rodzajem i wysokością roszczenia, w tym
                                    poświadczających
                                    uprawnienia do bezpłatnych lub ulgowych przejazdów.</p>
                                <p><strong>8.9.</strong> Jeżeli wniesiona reklamacja nie spełnia powyższych warunków,
                                    Przewoźnik
                                    wzywa
                                    reklamującego, aby usunął braki w terminie 14 dni od dnia otrzymania wezwania, z
                                    pouczeniem, że
                                    nieuzupełnienie braków w tym terminie spowoduje pozostawienie reklamacji bez
                                    rozpoznania.
                                    Wówczas za
                                    datę wniesienia reklamacji przyjmuje się datę otrzymania przez Przewoźnika
                                    uzupełnionej
                                    reklamacji.</p>
                                <p><strong>8.10.</strong> Przewoźnik rozpatrzy reklamację lub skargę w terminie 14 dni
                                    roboczych od
                                    dnia ich
                                    otrzymania, z zastrzeżeniem sytuacji, w których zaistnieje potrzeba uzyskania
                                    dodatkowych
                                    wyjaśnień od
                                    Pasażera.</p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/components/home/homeComponents/regulaminComponents/RegulaminPrzewozow.js